import { css } from '@emotion/react';
import {
  FoundationIcon,
  Icon,
  NeutralColorToken,
  SemanticColorToken,
  Type,
  mediaQueryForExperimentalLayoutSizeMDOrSmaller,
} from '@robinhood/design';

import GradientBackgroundLayout from './GradientBackgroundLayout';
import RobinhoodGoldCardLogo from 'src/assets/vectors/RobinhoodGoldCardLogo';

interface PropsIface {
  title: string;
  subtitle?: string | React.ReactNode;
  showLogo?: boolean;
  icon?: Icon;
}

const CreditApplicationPageLayout = ({
  title,
  subtitle,
  children,
  icon,
  showLogo = true,
}: React.PropsWithChildren<PropsIface>) => {
  return (
    <GradientBackgroundLayout>
      {showLogo && <RobinhoodGoldCardLogo css={logo} />}
      {icon && (
        <div css={iconContainer}>
          <FoundationIcon type={icon} color={SemanticColorToken.Positive} />
        </div>
      )}
      <div css={textHeader}>
        {/* TODO (szhang): Support martina font */}
        <Type.Display font='nib' size='L'>
          {title}
        </Type.Display>
        <Type.Text size='M' color={NeutralColorToken.Fg2}>
          {subtitle}
        </Type.Text>
      </div>
      <div css={contentContainer}>{children}</div>
    </GradientBackgroundLayout>
  );
};

export default CreditApplicationPageLayout;

const logo = css`
  margin-bottom: 40px;

  ${mediaQueryForExperimentalLayoutSizeMDOrSmaller} {
    margin-bottom: 16px;
  }
`;

// TODO (szhang): Figure out how to restrict width of form/header content
const textHeader = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 24px;
  margin-bottom: 32px;

  ${mediaQueryForExperimentalLayoutSizeMDOrSmaller} {
    gap: 8px;
    margin-bottom: 24px;
  }
`;

const contentContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const iconContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 40px;

  ${mediaQueryForExperimentalLayoutSizeMDOrSmaller} {
    margin-bottom: 16px;
  }

  & svg {
    width: 52px;
    height: 52px;
  }
`;
